/**
 * Borrower form validation
 */

import { errorMessages } from './errorMessages';
import type { ValidationResult } from './types';
import { validators } from './validators';

export type BorrowerFormData = {
  firstName: string;
  middleName: string;
  lastname: string;
  dateOfBirth: string;
  email: string;
  phone: string;
  countryCode: string;
  password: string;
  repeatPassword: string;
  acceptedTerms: boolean;
};

export const validateBorrowerForm = (form: BorrowerFormData, includeTerms = true): ValidationResult => {
  const errors: Partial<Record<keyof BorrowerFormData, string[]>> = {};

  // Name fields
  const firstNameError = errorMessages.name(form.firstName, 'First name');
  if (firstNameError) errors.firstName = [firstNameError];

  const lastnameError = errorMessages.name(form.lastname, 'Last name');
  if (lastnameError) errors.lastname = [lastnameError];

  // Middle name is optional but must be valid if provided
  if (form.middleName && !validators.name(form.middleName)) {
    errors.middleName = ['Middle name contains invalid characters'];
  }

  // Contact fields
  const emailError = errorMessages.email(form.email);
  if (emailError) errors.email = [emailError];

  const phoneError = errorMessages.phone(form.phone);
  if (phoneError) errors.phone = [phoneError];

  // Other fields
  const dobError = errorMessages.dateOfBirth(form.dateOfBirth);
  if (dobError) errors.dateOfBirth = [dobError];

  const passwordError = errorMessages.password(form.password);
  if (passwordError) errors.password = [passwordError];

  const confirmError = errorMessages.passwordConfirm(form.password, form.repeatPassword);
  if (confirmError) errors.repeatPassword = [confirmError];

  // Terms
  if (includeTerms && !form.acceptedTerms) {
    errors.acceptedTerms = ['You must agree to the Privacy Policy'];
  }

  const errorList = Object.values(errors).flat();

  return {
    isValid: errorList.length === 0,
    errors,
    firstError: errorList[0],
  };
};
